export const SECONDARY_JAUNE_COLOR = "#FFCD00";
export const PRIMARY_LIGHT_COLOR = "#5273A7";
export const PRIMARY_BLUE_COLOR = "#001D4A";
export const SECONDARY_BTN_COLOR = "transparent";


// WEBPACK FOOTER //
// ./src/opencell/constants/colors.js